import { render, staticRenderFns } from "./formLabel.vue?vue&type=template&id=1bc12561&"
import script from "./formLabel.vue?vue&type=script&lang=js&"
export * from "./formLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports